<template>
  <section class="xl:py-24 lg:py-20 md:py-10 py-10" :class="[bg]">
    <div class="mx-auto max-w-7xl xl:px-1 md:px-5 px-2.5">
      <h1
        v-if="title"
        class="xl:text-5xl md:text-4xl text-3xl font-bold text-center mx-auto w-3/5"
      >
        {{ title }}
      </h1>
      <p
        v-if="description"
        class="lg:text-base text-sm text-gray-500 text-center mt-3.5 max-w-md mx-auto"
      >
        {{ description }}
      </p>
      <div :class="title ? 'mt-10' : ''">
        <slot></slot>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps<{
  title?: string;
  description?: string;
  bg?: string;
}>();
</script>
